import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { ajax } from '@blade/common';
let Queue = class Queue extends VuexModule {
    taskId = '';
    deviceId = '';
    async getDaySummay() {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/crowd-record-management/api/v1/queue/dashboard/aggregate/daySummary',
                // data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getHeat() {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/crowd-record-management/api/v1/queue/dashboard/aggregate/taskHeatValues',
                // data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getQueueTaskbyID(taskId, cancelToken) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/crowd-record-management/api/v1/queue/queueTasks/${taskId}`,
                // data: data,
                cancelToken: cancelToken,
            });
            console.log('res:', res.data);
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getQueueingCount(deviceId) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/crowd-record-management/api/v1/queue/aggregate/aggregateAndForecastQueueingCount/${deviceId}`,
                // data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getRtsp(data) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/camera-device-management/api/v1/devices/${data.deviceId}/${data.taskId || 54}/RTSPPreviewAddress`,
                // data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async deleteTask(taskId) {
        try {
            const res = await ajax.request({
                method: 'DELETE',
                url: `/api/task-management/api/v1/combined/task/${taskId}`,
                // data: data,
            });
        }
        catch (e) {
            throw e;
        }
    }
    async getTaskByDeviceId(data) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/task-management/api/v1/combined/task/${data.taskId}/device/${data.deviceId}`,
                // data: data,
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getTaskTypes() {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/task-management/api/v1/combined/task/listByType',
                data: { taskType: 9 },
            });
            return res.data;
        }
        catch (e) {
            throw e;
        }
    }
    updateUrl(payload) { }
    updateTaskId(payload) {
        this.taskId = payload;
    }
    updateDeviceId(payload) {
        console.log('deviceId:', payload);
        this.deviceId = payload;
    }
};
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getDaySummay", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getHeat", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getQueueTaskbyID", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getQueueingCount", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getRtsp", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "deleteTask", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getTaskByDeviceId", null);
__decorate([
    Action({ rawError: true })
], Queue.prototype, "getTaskTypes", null);
__decorate([
    Mutation
], Queue.prototype, "updateUrl", null);
__decorate([
    Mutation
], Queue.prototype, "updateTaskId", null);
__decorate([
    Mutation
], Queue.prototype, "updateDeviceId", null);
Queue = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/Queue' })
], Queue);
export const QueueModule = getModule(Queue);
